// extracted by mini-css-extract-plugin
export var actionText = "_no-4";
export var container = "_no-0";
export var leftSection = "_no-1";
export var rightSection = "_no-2";
export var settingsButton = "_no-6";
export var settingsIcon = "_no-7";
export var shortcut = "_no-5";
export var shortcutGroup = "_no-3";